const MINIMUM_FUZZY_MATCH_LENGTH = 3;

// svc-vendor holds full brand names (e.g. "AccorHotels") while Salesforce's Chain__c picklist
// holds a short canonical token (e.g. "Accor") matched by strict equality -- strip known
// corporate suffixes to bridge the two.
const CHAIN_NAME_LOOKUP_SUFFIXES = [
  'hotels & resorts',
  'hotels and resorts',
  'hotels',
  'resorts',
  'worldwide',
  'international',
  'group',
  'limited',
  'ltd',
];

export function normalizeChainNameForLookup(chainName?: string | null): string | undefined {
  let normalized = (chainName ?? '').trim();
  // "The " is only noise when paired with a suffix strip below -- some Chain__c values are
  // themselves "The X" (e.g. "The Star"), so never strip it alone.
  let strippedAnySuffix = false;

  for (let changed = true; changed; ) {
    changed = false;

    for (const suffix of CHAIN_NAME_LOOKUP_SUFFIXES) {
      const suffixPattern = new RegExp(`\\s*${suffix}$`, 'i');
      if (suffixPattern.test(normalized)) {
        normalized = normalized.replace(suffixPattern, '').trim();
        changed = true;
        strippedAnySuffix = true;
        break;
      }
    }
  }

  if (strippedAnySuffix) {
    normalized = normalized.replace(/^the\s+/i, '').trim();
  }

  return normalized || undefined;
}

export function normalizeRuleText(value?: string | null) {
  return (value ?? '').trim().toLowerCase();
}

export function hasRuleValue(value?: string | null) {
  return !!normalizeRuleText(value);
}

export function uniqueNormalizedValues(values: Array<string | null | undefined>) {
  return Array.from(new Set(values.map((value) => normalizeRuleText(value)).filter(Boolean)));
}

export function fuzzyValuesMatch(left?: string | null, right?: string | null) {
  const normalisedLeft = normalizeRuleText(left);
  const normalisedRight = normalizeRuleText(right);
  const allowFuzzyMatch =
    normalisedLeft.length >= MINIMUM_FUZZY_MATCH_LENGTH && normalisedRight.length >= MINIMUM_FUZZY_MATCH_LENGTH;

  return (
    !!normalisedLeft &&
    !!normalisedRight &&
    (normalisedLeft === normalisedRight ||
      (allowFuzzyMatch && (normalisedLeft.includes(normalisedRight) || normalisedRight.includes(normalisedLeft))))
  );
}
